// What the shared DOM components (@todo/web-ui) show on miami-todo.com: the
// logo, the menus, the lists and the mockup's photos. @todo/web-ui reads it as
// the `@site-ui` alias (tsconfig.json), as @todo/core reads src/site.ts as `@site`.

import type { SiteUi } from '@todo/web-ui/lib/site-ui';

import { BrandLockup } from '@/components/brand-lockup';
import { CATEGORY_STRIP, COLLECTIONS, HUB_GUIDES } from '@/lib/collections';
import {
  FOOTER_IMAGE,
  HEADER_CORNER,
  HERO_IMAGE,
  HERO_SIZE,
  HERO_SRCSET,
  MOOD_TILES,
  SAMPLE_CARDS,
} from '@/lib/placeholders';

export const SITE_UI = {
  BrandLockup,
  // The plan's menu (stage 3 of docs/miami-plan.md) in place of the mockup's
  // Restaurants / Nightlife / Family / Art & Culture: the catalog's sections.
  // No Events or Guides until they have data.
  nav: [
    { key: 'nav.tours', path: 'tours' },
    { key: 'nav.boats', path: 'boats' },
    { key: 'nav.everglades', path: 'everglades' },
    { key: 'nav.dayTrips', path: 'day-trips' },
    { key: 'nav.attractions', path: 'attractions' },
  ],
  footer: {
    thingsToDo: [
      { key: 'footer.tours', short: 'nav.tours', path: 'tours' },
      { key: 'collections.boats.title', path: 'boats' },
      { key: 'collections.everglades.title', short: 'nav.everglades', path: 'everglades' },
      { key: 'collections.day-trips.title', path: 'day-trips' },
      { key: 'collections.water-sports.title', path: 'water-sports' },
    ],
    areas: [
      { key: 'collections.south-beach.title', path: 'south-beach' },
      { key: 'collections.wynwood.title', path: 'wynwood' },
      { key: 'collections.little-havana.title', path: 'little-havana' },
      { key: 'collections.brickell.title', path: 'brickell' },
    ],
  },
  // The sister sites, the closest catalog first. A locale one doesn't have (ES) links to its /en.
  sisterSites: [
    { name: 'Dubai To-Do', url: 'https://dubai-todo.com', locales: ['en', 'de', 'ru'] },
    { name: 'Riviera To-Do', url: 'https://riviera-todo.com', locales: ['en', 'fr', 'ru'] },
  ],
  collections: COLLECTIONS,
  hubGuides: HUB_GUIDES,
  categoryStrip: CATEGORY_STRIP,
  // The mockup's palm frond, hanging into the header's top-left corner. (On the
  // home page the hero's photo runs under the header: its own palms reach the bar.)
  headerCorner: HEADER_CORNER,
  hero: { image: HERO_IMAGE, ...HERO_SIZE, srcSet: HERO_SRCSET },
  // The photo of the mockup's newsletter band (the block itself is dropped): the bay under a white veil.
  footerImage: FOOTER_IMAGE,
  moodTiles: MOOD_TILES,
  sampleCards: SAMPLE_CARDS,
} as const satisfies SiteUi;
